import { NO_OF_FILTER_TO_SHOW } from '@constants'

type KPIRollUps = {
  quantity: number
  value: number
  aws: string | number
  depth: string | number
  sku: string | number
  salesQuantity?: number
  storeCount?: string | number
}

const getModelDescription = (modelDescription, model) => {
  if (modelDescription.includes(model)) {
    return modelDescription.replace(`${model} - `, '')
  }
  return modelDescription
}

/**
 *
 */
const getActivityValue = finalFilterToApply => {
  if (finalFilterToApply['Status'] && finalFilterToApply['Status'].length === 1) {
    return finalFilterToApply['Status'][0].label !== 'Inactive'
  }

  return undefined
}

/**
 * Returns selected favourite value
 */
const getFavouriteValue = finalFilterToApply => {
  if (
    finalFilterToApply['Favourite Filter'] &&
    finalFilterToApply['Favourite Filter'].length === 1
  ) {
    return finalFilterToApply['Favourite Filter'][0].label === 'Favourite'
  }
  return undefined
}

/**
 * Return filter values ids
 */

const getFilterValues = (finalFilterToApply, filterConst) => {
  if (finalFilterToApply[filterConst] && finalFilterToApply[filterConst].length) {
    return finalFilterToApply[filterConst].map(({ value }) => value)
  }
  return undefined
}

/**
 * Returns rating value
 */
const getRatingValue = finalFilterToApply => {
  if (
    finalFilterToApply['Rating Filter'] &&
    finalFilterToApply['Rating Filter'].length === 1
  ) {
    return finalFilterToApply['Rating Filter'][0].label === 'Rated'
  }
  return undefined
}
/**
 *
 * @param object
 *
 */

const getProductStatusFilter = finalFilterToApply => {
  if (
    finalFilterToApply['Core Status'] &&
    finalFilterToApply['Core Status'].length === 1
  ) {
    return finalFilterToApply['Core Status'][0].label === 'Core' ? 'CORE' : 'NON_CORE'
  }
  return undefined
}

/**
 * Returns filter value needed for GraphQL Query
 */
const getFavouriteFilter = (favouriteValue, user) => {
  let favouriteFilterSome
  let favouriteFilterEvery

  if (typeof favouriteValue !== 'undefined') {
    if (favouriteValue) {
      favouriteFilterEvery = undefined
      favouriteFilterSome = { user: { id: user.id } }
    } else {
      favouriteFilterSome = undefined
      favouriteFilterEvery = { user: { id: null } }
    }
  }

  return {
    favouriteFilterSome,
    favouriteFilterEvery
  }
}

/**
 * Returns filter value needed for GraphQL Query
 */
const getRatingFilter = finalFilterToApply => {
  const ratingValue = getRatingValue(finalFilterToApply)
  let ratingFilterSome
  let ratingFilterNone

  if (typeof ratingValue !== 'undefined') {
    if (ratingValue) {
      ratingFilterNone = undefined
      ratingFilterSome = { value_gt: 0 }
    } else {
      ratingFilterNone = undefined
      ratingFilterNone = { value_gt: 0 }
    }
  }

  return {
    ratingFilterSome,
    ratingFilterNone
  }
}

const getFilterChipsData = finalFilterToApply => {
  const chipsArrayToDisplay = []
  const chipsArrayInDropDown = []

  Object.keys(finalFilterToApply).forEach(filter => {
    finalFilterToApply[filter] &&
      finalFilterToApply[filter].forEach(item => {
        if (chipsArrayToDisplay.length < NO_OF_FILTER_TO_SHOW) {
          chipsArrayToDisplay.push({ ...item, filterKey: filter })
        } else {
          chipsArrayInDropDown.push({ ...item, filterKey: filter })
        }
      })
  })
  return {
    chipsArrayToDisplay: chipsArrayToDisplay || [],
    chipsArrayInDropDown: chipsArrayInDropDown || []
  }
}

export type { KPIRollUps }
export {
  getActivityValue,
  getFavouriteValue,
  getFavouriteFilter,
  getRatingFilter,
  getProductStatusFilter,
  getFilterChipsData,
  getModelDescription,
  getFilterValues
}
